import { HelpTooltip } from '@alkem/react-ui-helptooltip';
import classNames from 'classnames';
import {
  ChangeEvent,
  InputHTMLAttributes,
  PureComponent,
  ReactNode,
} from 'react';
import { InputDisabled } from '../input-disabled';
import './index.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  emptyValueString: string;
  helpMessage?: string;
  inputClassName?: string;
  invalid?: boolean;
  label?: string;
  numberErrorString: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  valuesToIgnore: any[];
}

export class Text extends PureComponent<Props> {
  public static defaultProps = {
    className: '',
    disabled: false,
    emptyValueString: '(empty)',
    helpMessage: null,
    inputClassName: '',
    invalid: false,
    label: '',
    maxLength: null,
    name: null,
    numberErrorString: null,
    placeholder: '',
    type: 'text',
    valuesToIgnore: [],
  };

  private onChange = (event: ChangeEvent<HTMLInputElement>): void => {
    event.target.value = event.target.value.replace(/[^\d-.,]/g, '');
    this.props.onChange(event);
  };

  public render() {
    const {
      className,
      disabled,
      emptyValueString,
      helpMessage,
      id,
      inputClassName,
      invalid,
      label,
      maxLength,
      numberErrorString,
      onChange,
      type,
      value,
      valuesToIgnore,
      ...otherProps
    } = this.props;
    const htmlId = `InputText-${id}`;

    let labelRendered: ReactNode;
    const fieldColClass = {
      InputField__input: true,
    };
    if (label) {
      labelRendered = (
        <label htmlFor={htmlId} className="InputField__label col-xs-4">
          <span className="InputText__label">{label}</span>
          {helpMessage ? (
            <span className="InputText__help">
              <HelpTooltip id={htmlId} message={helpMessage} />
            </span>
          ) : null}
        </label>
      );
      fieldColClass['col-xs-8'] = true;
    } else {
      labelRendered = null;
      fieldColClass['col-xs-12'] = true;
    }

    const inputProps = {
      ...otherProps,
      id: htmlId,
      onChange: type === 'number' ? this.onChange : onChange,
      className: classNames(
        inputClassName,
        'InputText__input',
        'form-control',
        { 'InputText__input--invalid': invalid }
      ),
      type: type === 'number' ? 'text' : type,
      value: value === null ? '' : value,
      maxLength: maxLength !== null ? maxLength : undefined,
      disabled,
    };

    return (
      <div className={classNames(className, 'InputField', 'InputText', 'row')}>
        {labelRendered}
        <span className={classNames(fieldColClass)}>
          {disabled ? (
            <InputDisabled
              id={id}
              value={value}
              emptyValueString={emptyValueString}
            />
          ) : (
            <input {...inputProps} />
          )}
          {type === 'number' &&
            !valuesToIgnore.includes(value) &&
            Number.isNaN(Number(value)) &&
            numberErrorString && (
              <span className="InputText__NumberError">
                {numberErrorString}
              </span>
            )}
        </span>
      </div>
    );
  }
}
